import { dateDiff, type TimeDifference } from "./date";

const defaultOfflineThreshold = 10;
export const offlineThreshold = defaultOfflineThreshold;

export const isOffline = ({
  timestamp,
  offlineThreshold: threshold,
}: {
  timestamp: string | Date;
  offlineThreshold: number;
}): boolean => {
  const checkDateDiff: TimeDifference = dateDiff(timestamp, threshold);
  return checkDateDiff?.diffInMinutes >= threshold;
};

/**
 * Offline when unreachable via hands-free: no heartbeat or last heartbeat older than `offlineThreshold` minutes.
 * Kept in sync with `sqlMembershipIsOffline` in `membershipOfflineSql.ts`.
 */
export const isWorkspaceMembershipOffline = ({
  handsFreeUpdatedAt,
  offlineThreshold: threshold = defaultOfflineThreshold,
}: {
  handsFreeUpdatedAt: string | Date | null | undefined;
  offlineThreshold?: number;
}): boolean => {
  if (!handsFreeUpdatedAt) return true;
  return isOffline({ timestamp: handsFreeUpdatedAt, offlineThreshold: threshold });
};
